module.exports = __webpack_public_path__ + "img/axioma.150154c.jpg";